/**
 * en-GB messages added by Phase 3 task S25 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s25EnGB = {
    'remote.not_allowed': 'Your group is not allowed to work remotely. Please ask your administrator.',
    'remote.outside_geofence': 'You are too far from this site to sign in here.',
    'error.remote_site_limit': 'Your plan allows {max} remote sites.',
    'error.remote_site_has_visits': 'This remote site has sign-ins, so it cannot be deleted. Archive it instead.',
};
//# sourceMappingURL=s25.js.map